/**
 * Login page: full-screen, no sidebar. Renders one of checking | channelError | loading | error
 * based on teamsChannelStatus and userDataLoadStatus. Success = main app (layout does not render this).
 */
import React from "react";
import { USER_DATA_LOAD_STATUS, TEAMS_CHANNEL_STATUS } from "../../redux/constants/metaData";
import {
  SKIP_AUTH_DIALOG_AFTER_CANCEL,
  SKIP_AUTH_DIALOG_AFTER_LOGOUT,
} from "../../services/authService";
import CheckingView from "./components/CheckingView";
import ChannelErrorView from "./components/ChannelErrorView";
import LoadingView from "./components/LoadingView";
import LoginErrorView from "./components/LoginErrorView";

const LOADING_STATUSES = [
  USER_DATA_LOAD_STATUS.onStart,
  USER_DATA_LOAD_STATUS.onLoading,
  USER_DATA_LOAD_STATUS.onAzureUserAuthentication,
  USER_DATA_LOAD_STATUS.onIFSUserValidation,
  USER_DATA_LOAD_STATUS.onIFSUserLogin,
];

export default function LoginPage({
  innerRef,
  imgStyles,
  teamsChannelStatus,
  userDataLoadStatus,
  messageBoxInfo,
  onRetry,
}) {
  const shouldShowManualLogin =
    userDataLoadStatus === USER_DATA_LOAD_STATUS.onStart &&
    typeof localStorage !== "undefined" &&
    (localStorage.getItem(SKIP_AUTH_DIALOG_AFTER_LOGOUT) ||
      localStorage.getItem(SKIP_AUTH_DIALOG_AFTER_CANCEL));

  if (teamsChannelStatus === TEAMS_CHANNEL_STATUS.CHECKING) {
    return <CheckingView innerRef={innerRef} imgStyles={imgStyles} />;
  }

  if (teamsChannelStatus === TEAMS_CHANNEL_STATUS.INVALID) {
    return <ChannelErrorView onRetry={onRetry} />;
  }

  if (LOADING_STATUSES.includes(userDataLoadStatus)) {
    if (shouldShowManualLogin) {
      return (
        <LoginErrorView
          messageBoxInfo={messageBoxInfo}
          onRetry={onRetry}
          userDataLoadStatus={userDataLoadStatus}
        />
      );
    }
    return (
      <LoadingView
        innerRef={innerRef}
        imgStyles={imgStyles}
        userDataLoadStatus={userDataLoadStatus}
        message={messageBoxInfo?.message}
      />
    );
  }

  return (
    <LoginErrorView
      messageBoxInfo={messageBoxInfo}
      onRetry={onRetry}
      userDataLoadStatus={userDataLoadStatus}
    />
  );
}
